<template>
  <div class="full relative">

    <div class="padder"></div>
    <div class="flex" :class="{ 'padder-content': isFull }">
      <DocsLeftMenu v-if="isFull" class="hidden lg:block"></DocsLeftMenu>
      <div class="w-full" :class="{ 'right-content': isFull }">
        <slot></slot>
        <router-view @toggle-fullscreen="toggleFullscreen"></router-view>
      </div>
    </div>

    <MenuBar></MenuBar>
  </div>
</template>

<script>
export default {
  mixins: [
    require('../../Reusable/O3DCompos').O3DCompos
  ],
  data () {
    return {
      isFull: true
    }
  },
  methods: {
    toggleFullscreen () {
      this.isFull = !this.isFull
      this.$nextTick(() => {
        window.dispatchEvent(new Event('resize'))
      })
    }
  }
}

// paitence is enjoying now
// patience is enojoying life
</script>

<style lang="postcss">
.padder{
  height: 56px;
}
.padder-content{
  height: calc(100% - 56px);
}
@screen lg {
  .right-content{
    width: calc(100% - 285px);
  }
}
</style>
